
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 54 36"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#002b7f","d":"M0 0h54v36H0z"}}),_c('path',{attrs:{"d":"M0 22.5h54V27H0z","fill":"#f9e814"}}),_c('g',{attrs:{"fill":"#fff","id":"d"}},[_c('g',{attrs:{"id":"c"}},[_c('g',{attrs:{"id":"b"}},[_c('path',{attrs:{"d":"M12 8v4h2z","transform":"rotate(18 12 8)","id":"a"}}),_c('use',{attrs:{"xlink:href":"#a","x":"-24","transform":"scale(-1 1)"}})]),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(72 12 12)"}})]),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(-72 12 12)"}}),_c('use',{attrs:{"xlink:href":"#c","transform":"rotate(144 12 12)"}})]),_c('use',{attrs:{"xlink:href":"#d","x":"-4","y":"-4","transform":"scale(.75)"}})])
          )
        }
      }
    